import React, { useState } from 'react';
import LoadHistoryEventCard from './LoadHistoryEventCard';
import { Pagination } from '../../../components/pagination';
import './LoadHistoryTimeline.scss';

/**
 * Load History Timeline Component
 * Displays chronological list of load history events with pagination
 */
const LoadHistoryTimeline = ({ events = [], pagination, onPageChange }) => {
  const [expandedEvents, setExpandedEvents] = useState(new Set());

  const toggleEvent = (eventId) => {
    setExpandedEvents(prev => {
      const next = new Set(prev);
      if (next.has(eventId)) {
        next.delete(eventId);
      } else {
        next.add(eventId);
      }
      return next;
    });
  };

  if (events.length === 0) {
    return (
      <div className="load-history-timeline load-history-timeline--empty">
        <p>No history found for this load.</p>
      </div>
    );
  }

  return (
    <div className="load-history-timeline">
      <div className="load-history-timeline__events">
        {events.map((event, index) => (
          <LoadHistoryEventCard
            key={event._id || index}
            event={event}
            isExpanded={expandedEvents.has(event._id || index)}
            onToggle={() => toggleEvent(event._id || index)}
          />
        ))}
      </div>

      {pagination && pagination.totalPages > 1 && (
        <div className="load-history-timeline__pagination">
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default LoadHistoryTimeline;
